import { Link } from 'react-router-dom'
import { ASSETS } from '../../../assets';
import { pages } from '../../../config/routes';
import Logo from '../../logo'
import './styles.scss'

function DesktopFooter() {
    const CLASS_NAME = "desktop-footer"
    return <div className={CLASS_NAME}>
        <div className={`${CLASS_NAME}-container flex-center`}>
            <div className="flex-column">
                <div className={`flex-spread ${CLASS_NAME}-logos`}>
                    <Logo />
                    <div className={`${CLASS_NAME}-logo-container`}>
                        <img src={ASSETS.MBE_LOGO} alt="MBE Logo" className="mbe-logo" />
                        <img className="hubzone-logo" src={ASSETS.HUBZONE_LOGO} alt="Hubzone Logo"/>
                    </div>
                </div>
                <p className={`${CLASS_NAME}-copyright`}>Copyright © 2021 Ypsilanti, MI</p>
            </div>
            <div className={`${CLASS_NAME}-links`}>
                <div className={`${CLASS_NAME}-about flex-column`}>
                    <span>About</span>
                    <Link to={pages.home}>Home</Link>
                    <Link to={pages.contact}>Contact</Link>
                </div>
                <div className={`${CLASS_NAME}-experience flex-column`}>
                    <span>Experience</span>
                    <Link to={pages.capabilities}>Capabilities</Link>
                    <Link to={pages.whyKeyes2Safety}>Why Keyes2Safety?</Link>
                </div>
            </div>
        </div>
    </div>;
}

export default DesktopFooter;